import { Component, ContentChildren, Input, QueryList, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { GenericModalService, ModalSettingsTemplate } from '../../generic-modal/generic-modal.service';
import { ChangeLogLinkEntityDirective } from '../change-log-link-entity/change-log-link-entity.directive';
import { EntityIdentifier } from '../models/change-log-request';

import { SvgIconComponent } from '../../icons/svg-icon.component';
import { ChangeLogSearchComponent } from '../change-log-search/change-log-search.component';
import { ChangeLogViewerComponent } from '../change-log-viewer/change-log-viewer.component';

@Component({
    selector: 'app-change-log-link',
    templateUrl: './change-log-link.component.html',
    styleUrls: ['./change-log-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, ChangeLogSearchComponent, ChangeLogViewerComponent]
})
export class ChangeLogLinkComponent {
  @ViewChild('logTemplate') logTemplate: TemplateRef<any>;
  @ContentChildren(ChangeLogLinkEntityDirective, { emitDistinctChangesOnly: false }) entityList: QueryList<ChangeLogLinkEntityDirective>;

  @Input() disabled = false;
  @Input() classNames = 'btn btn-link';
  @Input() showIcon = true;
  @Input() title = 'Change log';

  entities: EntityIdentifier[] = [];

  constructor(
    private genericModalService: GenericModalService) {
  }

  async showLogClick(e: any): Promise<void> {
    e.preventDefault();
    if (this.disabled) {
      return;
    }
    this.entities = this.entityList.map(e => ({ entityType: e.type, entityId: e.id, includeChildren: e.includeChildren, includeGrandChildren: e.includeGrandChildren }) as EntityIdentifier);

    try {
      const settings = new ModalSettingsTemplate('lg', 'static');
      settings.windowClass = 'hugeModal';
      await this.genericModalService.openTemplate(this.logTemplate, settings);
    }
    catch (err) {
      console.error(err);
    }
  }
}
